export enum OPPORTUNITY_TYPES {
  event = 'event',
  exclusive = 'exclusive_event',
  regular = 'regular',
}
